import React, { useContext } from "react";
import classes from "./Contact.module.css";
import { AiOutlineMail } from "react-icons/ai";
import { RiPhoneLine } from "react-icons/ri";
import { ThemeContext } from "../../ThemeProvider";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";

const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Contact = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <Reveal
      keyframes={customAnimation}
      triggerOnce="true"
      duration={1000}
      fraction={0.2}
    >
      <div className={classes.contact} id="contact">
        <p
          className={
            dark
              ? `${classes.top__text} ${classes.top__text__dark}`
              : classes.top__text
          }
        >
          05. &nbsp; What's &nbsp; Next?
        </p>
        <h1
          className={
            dark ? `${classes.title} ${classes.title__dark}` : classes.title
          }
        >
          Please Reach Out
        </h1>
        <p
          className={
            dark
              ? `${classes.description} ${classes.description__dark}`
              : classes.description
          }
        >
          I am looking for exciting opportunities in Frontend Engineering or
          Full stack(Frontend heavy) .
        </p>
        <div
          className={
            dark
              ? `${classes.contact__links} ${classes.contact__links__dark}`
              : classes.contact__links
          }
        >
          <p className={`${classes.mail} ${classes.link}`}>
            <a href="mailto:partharoyy44@gmail.com">
              <AiOutlineMail />
            </a>
          </p>
          <p className={`${classes.call} ${classes.link}`}>
            <a href="tel:+919650199719">
              <RiPhoneLine />
            </a>
          </p>
        </div>
      </div>
    </Reveal>
  );
};

export default Contact;
